(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlin-wrappers-kotlin-react-js-legacy', 'react-router-dom', 'kotlin-wrappers-kotlin-extensions-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlin-wrappers-kotlin-react-js-legacy'), require('react-router-dom'), require('kotlin-wrappers-kotlin-extensions-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'.");
    }if (typeof this['kotlin-wrappers-kotlin-react-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'. Its dependency 'kotlin-wrappers-kotlin-react-js-legacy' was not found. Please, check whether 'kotlin-wrappers-kotlin-react-js-legacy' is loaded prior to 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'.");
    }if (typeof this['react-router-dom'] === 'undefined') {
      throw new Error("Error loading module 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'. Its dependency 'react-router-dom' was not found. Please, check whether 'react-router-dom' is loaded prior to 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'.");
    }if (typeof this['kotlin-wrappers-kotlin-extensions-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'. Its dependency 'kotlin-wrappers-kotlin-extensions-js-legacy' was not found. Please, check whether 'kotlin-wrappers-kotlin-extensions-js-legacy' is loaded prior to 'kotlin-wrappers-kotlin-react-router-dom-js-legacy'.");
    }root['kotlin-wrappers-kotlin-react-router-dom-js-legacy'] = factory(typeof this['kotlin-wrappers-kotlin-react-router-dom-js-legacy'] === 'undefined' ? {} : this['kotlin-wrappers-kotlin-react-router-dom-js-legacy'], kotlin, this['kotlin-wrappers-kotlin-react-js-legacy'], this['react-router-dom'], this['kotlin-wrappers-kotlin-extensions-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kotlin_wrappers_kotlin_react_js_legacy, $module$react_router_dom, $module$kotlin_wrappers_kotlin_extensions_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var get_rClass = $module$kotlin_wrappers_kotlin_react_js_legacy.react.get_rClass_inwa2g$;
  var Any = Object;
  var throwCCE = Kotlin.throwCCE;
  var Enum = Kotlin.kotlin.Enum;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var throwISE = Kotlin.throwISE;
  var getKClass = Kotlin.getKClass;
  var Unit = Kotlin.kotlin.Unit;
  var BrowserRouterComponent = $module$react_router_dom.BrowserRouter;
  var SwitchComponent = $module$react_router_dom.Switch;
  var RouteComponent = $module$react_router_dom.Route;
  var LinkComponent = $module$react_router_dom.Link;
  var RedirectComponent = $module$react_router_dom.Redirect;
  var HashType$slash_instance;
  var HashType$noslash_instance;
  var HashType$hashbang_instance;
  function browserRouter$lambda$lambda(closure$basename, closure$getUserConfirmation, closure$forceRefresh, closure$keyLength) {
    return function ($receiver) {
      $receiver.basename = closure$basename;
      $receiver.getUserConfirmation = closure$getUserConfirmation;
      $receiver.forceRefresh = closure$forceRefresh;
      $receiver.keyLength = closure$keyLength;
      return Unit;
    };
  }
  function browserRouter$lambda(closure$basename, closure$getUserConfirmation, closure$forceRefresh, closure$keyLength, closure$handler) {
    return function ($receiver) {
      $receiver.attrs_slhiwc$(browserRouter$lambda$lambda(closure$basename, closure$getUserConfirmation, closure$forceRefresh, closure$keyLength));
      closure$handler($receiver);
      return Unit;
    };
  }
  function browserRouter($receiver, basename, getUserConfirmation, forceRefresh, keyLength, handler) {
    if (basename === void 0)
      basename = '';
    if (getUserConfirmation === void 0)
      getUserConfirmation = null;
    if (forceRefresh === void 0)
      forceRefresh = false;
    if (keyLength === void 0)
      keyLength = 6;
    return $receiver.child_ssazr1$(getKClass(BrowserRouterComponent), browserRouter$lambda(basename, getUserConfirmation, forceRefresh, keyLength, handler));
  }
  function switch_0($receiver, handler) {
    return $receiver.child_ssazr1$(getKClass(SwitchComponent), handler);
  }
  function route$lambda$lambda_0(closure$path, closure$exact, closure$strict, closure$render) {
    return function ($receiver) {
      $receiver.path = closure$path;
      $receiver.exact = closure$exact;
      $receiver.strict = closure$strict;
      $receiver.render = closure$render;
      return Unit;
    };
  }
  function route$lambda_0(closure$path, closure$exact, closure$strict, closure$render) {
    return function ($receiver) {
      $receiver.attrs_slhiwc$(route$lambda$lambda_0(closure$path, closure$exact, closure$strict, closure$render));
      return Unit;
    };
  }
  function route_0($receiver, path, exact, strict, render) {
    if (exact === void 0)
      exact = false;
    if (strict === void 0)
      strict = false;
    return $receiver.child_ssazr1$(getKClass(RouteComponent), route$lambda_0(path, exact, strict, render));
  }
  function route$lambda$lambda$lambda(closure$render) {
    return function (it) {
      return closure$render();
    };
  }
  function route$lambda$lambda_1(closure$path, closure$exact, closure$strict, closure$render) {
    return function ($receiver) {
      $receiver.path = closure$path;
      $receiver.exact = closure$exact;
      $receiver.strict = closure$strict;
      $receiver.render = route$lambda$lambda$lambda(closure$render);
      return Unit;
    };
  }
  function route$lambda_1(closure$path, closure$exact, closure$strict, closure$render) {
    return function ($receiver) {
      $receiver.attrs_slhiwc$(route$lambda$lambda_1(closure$path, closure$exact, closure$strict, closure$render));
      return Unit;
    };
  }
  function route_1($receiver, path, exact, strict, render) {
    if (exact === void 0)
      exact = false;
    if (strict === void 0)
      strict = false;
    return $receiver.child_ssazr1$(getKClass(RouteComponent), route$lambda_1(path, exact, strict, render));
  }
  function redirect$lambda$lambda(closure$from, closure$to, closure$push, closure$exact, closure$strict) {
    return function ($receiver) {
      $receiver.from = closure$from;
      $receiver.to = closure$to;
      $receiver.push = closure$push;
      $receiver.exact = closure$exact;
      $receiver.strict = closure$strict;
      return Unit;
    };
  }
  function redirect$lambda(closure$from, closure$to, closure$push, closure$exact, closure$strict) {
    return function ($receiver) {
      $receiver.attrs_slhiwc$(redirect$lambda$lambda(closure$from, closure$to, closure$push, closure$exact, closure$strict));
      return Unit;
    };
  }
  function redirect($receiver, from, to, push, exact, strict) {
    if (from === void 0)
      from = null;
    if (push === void 0)
      push = false;
    if (exact === void 0)
      exact = false;
    if (strict === void 0)
      strict = false;
    return $receiver.child_ssazr1$(getKClass(RedirectComponent), redirect$lambda(from, to, push, exact, strict));
  }
  var package$react = _.react || (_.react = {});
  var package$router = package$react.router || (package$react.router = {});
  var package$dom = package$router.dom || (package$router.dom = {});
  $$importsForInline$$['kotlin-wrappers-kotlin-extensions-js-legacy'] = $module$kotlin_wrappers_kotlin_extensions_js_legacy;
  package$dom.browserRouter_ysa1x$ = browserRouter;
  package$dom.switch_jg12zk$ = switch_0;
  $$importsForInline$$['kotlin-wrappers-kotlin-react-js-legacy'] = $module$kotlin_wrappers_kotlin_react_js_legacy;
  package$dom.route_szp5ya$ = route_0;
  package$dom.route_gp7xrx$ = route_1;
  package$dom.redirect_fpttgj$ = redirect;
  return _;
}));

//# sourceMappingURL=kotlin-wrappers-kotlin-react-router-dom-js-legacy.js.map
